import { RouteRecordRaw } from 'vue-router';

import { ROUTE_NAMES } from '@/constants';

import { fetchCommonData } from './guards';
import { toNonVueRoute } from './utils';

const paymentsRoutes: RouteRecordRaw[] = [
  toNonVueRoute({
    path: '/payments/sign-up/?slug=:slug&type=:type&sfcid=:sfcid?&step=:step?',
    name: ROUTE_NAMES.PAYMENTS_SIGN_UP,
  }),
  {
    path: '/payment-program-select',
    name: ROUTE_NAMES.PAYMENT_PROGRAM_SELECT,
    component: () => import('@/pages/PaymentProgramSelect/PaymentProgramSelect.vue'),
    beforeEnter: [fetchCommonData],
    meta: {
      permissions: [{ rules: [({ userActiveCompany }) => Boolean(userActiveCompany?.staffId)] }],
    },
  },
];

export default paymentsRoutes;
